import {
  Button,
  Div,
  H3,
  Modal,
  P,
  PropsModal,
  lightTheme,
} from '@vgrubs/components';
import { Dispatch, SetStateAction } from 'react';

export const DeleteImageModal = ({
  deleteModal,
  closeModal,
  setRemoveImage,
  setImage,
}: PropsModal & {
  deleteModal: boolean;
  setRemoveImage: Dispatch<SetStateAction<boolean>>;
  setImage: Dispatch<SetStateAction<string | Blob | File | null>>;
}) => {
  const handleDelete = () => {
    setImage(null);
    setRemoveImage(true);
    closeModal?.();
  };

  return (
    <Modal
      isOpen={deleteModal}
      closeModal={closeModal}
      logo={false}
      zIndex={111}
      overlayBorderRadius={30}
    >
      <H3 $mb="24" $color={lightTheme.primary}>
        Are you sure
      </H3>
      <P $mb="40">Are you sure you want to remove this image?</P>

      <Div $flex $gap="16px">
        <Button onClick={handleDelete} $w="100%" $selected>
          Remove
        </Button>
        <Button $selected $gray $w="100%" onClick={() => closeModal?.()}>
          Cancel
        </Button>
      </Div>
    </Modal>
  );
};
